import { useState, useEffect } from 'react';
import { TrendingUp, Euro, Clock, Receipt } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'; // Per fer els gràfics
import './Rendibilitat.css';
import API_URL from '../config';

function Rendibilitat() {
  const [dadesRendibilitat, setDadesRendibilitat] = useState(null);
  const [carregant, setCarregant] = useState(true);
  const [error, setError] = useState('');
  const [paquetsDetall, setPaquetsDetall] = useState([]);
  const [dadesMensuals, setDadesMensuals] = useState([]);

  // Filtre Data i Sessions
  const [dataInici, setDataInici] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [sessionsSeleccionades, setSessionsSeleccionades] = useState('');
  const [llistaSessions, setLlistaSessions] = useState([]);

  // Filtre client
  const [llistaClients, setLlistaClients] = useState([]);
  const [cercaClient, setCercaClient] = useState('');
  const [clientSeleccionat, setClientSeleccionat] = useState('');
  const [clientNom, setClientNom] = useState(''); 
  const [mostrarDropdownClients, setMostrarDropdownClients] = useState(false);

  useEffect(() => { /* La linia de eslint es per evitar warnings que no afecten al funcionament */
    /* eslint-disable */ 
    carregarDades();
    carregarClients();
    carregarSessions();
  }, []);

  const carregarDades = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
        setCarregant(false);
        return;
    }

    try {
        // Construir els paràmetres de filtre
        const queryParams = new URLSearchParams();
        if (dataInici) queryParams.append('data_inici', dataInici);
        if (dataFinal) queryParams.append('data_final', dataFinal);
        if (clientSeleccionat) queryParams.append('client_id', clientSeleccionat);
        if (sessionsSeleccionades) queryParams.append('sessions', sessionsSeleccionades);

        // url per les kpis
        const urlKpis = `${API_URL}/api/business/rendibilitat/?${queryParams}`;
        
        // url per la llista de paquets
        const urlPaquets = `${API_URL}/api/business/rendibilitat/paquets/?${queryParams}`;

        // url per les dades mensuals
        const urlMensual = `${API_URL}/api/business/rendibilitat/mensual/?${queryParams}`;

        // Obtenir les dades de rendibilitat pels KPIs
        const responseKpis = await fetch(urlKpis, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
            }
        });

        if (responseKpis.ok) {
            const dataKpis = await responseKpis.json();
            setDadesRendibilitat(dataKpis);
        }

        // Obtenir les dades de rendibilitat dels paquets
        const responsePaquets = await fetch(urlPaquets, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
            }
        });

        if (responsePaquets.ok) {
            const dataPaquets = await responsePaquets.json();
            setPaquetsDetall(dataPaquets);
        }

        // Obtenir les dades mensuals pels gràfics
        const responseMensual = await fetch(urlMensual, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
            }
        });

        if (responseMensual.ok) {
            const dataMensual = await responseMensual.json();
            setDadesMensuals(dataMensual);
        }

    } catch (err) {
        console.error('Error carregant rendibilitat:', err);
        setError('Error al carregar les dades de rendibilitat');
    } finally {
        setCarregant(false);
    }
  };

  const carregarClients = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/clients/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setLlistaClients(data);
      }
    } catch (err) {
      console.error('Error carregant clients:', err);
    }
  };

  const carregarSessions = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/paquets/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Extreure valors únics de sessions_comprades i ordenar-los al dropdown
        const sessionsUniques = [...new Set(data.map(p => p.sessions_comprades))].sort((a, b) => a - b);
        setLlistaSessions(sessionsUniques);
      }
    } catch (err) {
      console.error('Error carregant sessions:', err);
    }
  };

  const aplicarFiltres = async () => {
  setCarregant(true);
  carregarDades();
  };

  if (carregant) {
    return (
      <div className="seccio-rendibilitat">
        <p>Carregant dades...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="seccio-rendibilitat">
        <div className="missatge-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="seccio-rendibilitat">
      
      <div className="capçalera">
        <h1>Rendibilitat del negoci</h1>
        <p>Anàlisi detallada dels ingressos, despeses i beneficis</p>
      </div>

      {/* FILTRES */}
      <div className="filtres">
        <h2>Filtres d'anàlisi</h2>
        <div className="grup-filtres">
          <label>
            Data inici:
            <input 
              type="date" 
              value={dataInici}
              onChange={(e) => setDataInici(e.target.value)}
            />
          </label>
          <label>
            Data final:
            <input 
              type="date" 
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
            />
          </label>
          <label>
            Client:
            <div className="contenidor-cerca-client">
              <input
                type="text"
                placeholder="Cerca client..."
                value={clientNom}
                onChange={(e) => {  
                  setClientNom(e.target.value);
                  setCercaClient(e.target.value);
                  setMostrarDropdownClients(true);
                  if (e.target.value === '') {
                    setClientSeleccionat('');
                  }
                }}
                onFocus={() => setMostrarDropdownClients(true)}
              />
              
              {mostrarDropdownClients && cercaClient && (
                <div className="dropdown-clients">
                  <div 
                    className="opcio-client"
                    onClick={() => {
                      setClientNom('');
                      setClientSeleccionat('');
                      setCercaClient('');
                      setMostrarDropdownClients(false);
                    }}
                  >
                    <strong>Tots els clients</strong>
                  </div>
                  {llistaClients
                    .filter(client => 
                      client.nom_complet.toLowerCase().includes(cercaClient.toLowerCase())
                    )
                    .slice(0, 10)
                    .map(client => (
                      <div
                        key={client.id}
                        className="opcio-client"
                        onClick={() => {
                          setClientSeleccionat(client.id);
                          setClientNom(client.nom_complet);
                          setMostrarDropdownClients(false);
                        }}
                      >
                        {client.nom_complet}
                      </div>
                    ))
                  }
                </div>
              )}
            </div>
          </label>
          <label>
            Sessions:
            <select 
              value={sessionsSeleccionades}
              onChange={(e) => setSessionsSeleccionades(e.target.value)}
            >
              <option value="">Tots</option>
              {llistaSessions.map(sessions => (
                <option key={sessions} value={sessions}>
                  {sessions} sessions
                </option>
              ))}
            </select>
          </label>
          <button onClick={aplicarFiltres}>Aplicar filtres</button>
        </div>
      </div>
      
      {/* KPIs */}
      {dadesRendibilitat && (
        <div className="kpis">
          <div className="kpi">
            <div>
              <h3>Ingressos totals</h3>
              <p>{dadesRendibilitat.ingres_total}€</p>
            </div>
            <TrendingUp size={24} />
          </div>
          <div className="kpi">
            <div>
              <h3>Cost temps intern</h3>
              <p>{dadesRendibilitat.cost_temps_intern}€</p>
            </div>
            <Clock size={24} />
          </div>
          <div className="kpi">
            <div>
              <h3>Despeses totals</h3>
              <p>{dadesRendibilitat.total_despeses}€</p>
            </div>
            <Receipt size={24} /> 
          </div>
          <div className="kpi">
            <div>
              <h3>Guany net</h3>
              <p>{dadesRendibilitat.guany_net}€</p>
            </div>
            <Euro size={24} />
          </div>
        </div>
      )}

      {/* GRÀFIC EVOLUCIO RENDIBILITAT */}
      <div className="grafic-complet">
        <h2>Evolució mensual de rendibilitat</h2>
        {dadesMensuals.length > 0 ? ( /* Comprovar si hi ha dades per mostrar */
          <ResponsiveContainer width="100%" height={400}>  
            <LineChart data={dadesMensuals} margin={{ top: 5, right: 30, left: 20, bottom: 15 }}> {/*Dades per al gràfic extretes de la funció de rendibilitat mensual*/}
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" /> {/* Línies de la graella del mig del grafic*/}
              {/* Estils de l'eix X */}
              <XAxis 
                dataKey="mes_nom" 
                tick={{ fill: '#4a5568', fontSize: 15 }}
                tickLine={{ stroke: '#e2e8f0' }}
                dy={10}
              />
              {/* Estils de l'eix Y */}
              <YAxis 
                tick={{ fill: '#4a5568', fontSize: 13 }}
                tickLine={{ stroke: '#e2e8f0' }}
                tickFormatter={(value) => `${value}€`}
                dx={-10}
              />
              {/* Estils per quan passes el ratolí per sobre dels punts del gràfic */}
              <Tooltip 
                formatter={(value) => `${Number(value).toFixed(2)}€`}
                contentStyle={{ 
                  background: 'white', 
                  border: '1px solid #215dab',
                  borderRadius: '8px',
                }}
              />
              {/* Estil de la llegenda del gràfic */}
              <Legend 
                iconType="line"
              />
              {/* Estils de les linies del gràfic */}
              <Line 
                type="monotone" 
                dataKey="ingressos" 
                stroke="#48bb78" 
                name="Ingressos" 
                strokeWidth={3}
                dot={{ fill: '#48bb78', r: 4 }}
                activeDot={{ r: 6 }}
              />
              <Line 
                type="monotone" 
                dataKey="cost" 
                stroke="#d32a2a" 
                name="Costos" 
                strokeWidth={3}
                dot={{ fill: '#d32a2a', r: 4 }}
                activeDot={{ r: 6 }}
              />
              <Line 
                type="monotone" 
                dataKey="guany" 
                stroke="#667eea" 
                name="Guany Net" 
                strokeWidth={3}
                dot={{ fill: '#667eea', r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <p className="missatge-buit">No hi ha dades per mostrar</p>
        )}
      </div>

      {/* TAULA RENDIBILITAT PER PAQUET*/}
      <div className="taula-rendibilitat">
        <h2>Rendibilitat per paquet</h2>
        <table className="taula-rendibilitat">
          <thead>
            <tr>
              <th>Client</th>
              <th>Sessions</th>
              <th>Ingressos</th>
              <th>Cost</th>
              <th>Guany</th>
              <th>ROI%</th>
            </tr>
          </thead>
          <tbody>
            {paquetsDetall.map(paquet => {
              const roi = paquet.ingres_paquet > 0 
                ? ((paquet.guany_net_paquet / paquet.ingres_paquet) * 100).toFixed(1)
                : 'N/A';
              
              return (
                <tr key={paquet.paquet_id}>
                  <td>{paquet.client}</td>
                  <td>{paquet.sessions_comprades}</td>
                  <td>{paquet.ingres_paquet}€</td>
                  <td>{paquet.cost_temps_intern}€</td>
                  <td>{paquet.guany_net_paquet}€</td>
                  <td>{roi}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Rendibilitat; 
